import getVariation from './getVariation';

const sortByAvailable = (attribute = {}) => (variations = []) => {
  var _attribute$values;

  const variationValues = (attribute == null ? void 0 : (_attribute$values = attribute.values) == null ? void 0 : _attribute$values.reduce((acc, value) => {
    const variation = getVariation(variations, value);
    return Object.assign({}, acc, {
      [value]: variation == null ? void 0 : variation.available
    });
  }, {})) || {};
  return Object.entries(variationValues).sort(([, a], [, b]) => b - a).map(([key]) => key);
};

export default sortByAvailable;